import { ValidatorFn, AbstractControl } from '@angular/forms';

export class CustomValidators {
  static get notContainsWhitespaceValidator(): ValidatorFn {
    return (control: AbstractControl): { [key: string]: any } => {
      if (control.value) {
        const isValid = (control.value || '').indexOf(' ') === -1;
        return isValid ? null : { containsWhitespace: true };
      }
      return null;
    };
  }
}
